<template>
  <div>
    <list-table
      :base="base"
      :optionCols="optionCols"
      :filterCols="filterCols"
      :srchFields="srchFields"
      :fetchList="fetchList"
      :showExSearch="showExSearch"
      :checkStatus="checkStatus"
      :deleteOne="deleteOne"
      :isReadOnly="false"
      :isShowDelBtn="true"
      :hasCreate="false"
      :nameField="nameField"
      :actWidth="250"
      ref="list"
    >
      <el-table-column
        align="center"
        :label="$t(`api.${base}.fields.from.label`)"
        :width="110"
      >
        <template slot-scope="scope">
          <el-tooltip
            class="item"
            effect="dark"
            placement="top"
            :content="scope.row.from_email"
          >
            <span>{{ scope.row.from_name }}</span>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        :label="$t(`api.${base}.fields.to.label`)"
      >
        <template slot-scope="scope">
          <p>{{ scope.row.to_email }}</p>
        </template>
      </el-table-column>
      <text-field
        :isForm="false"
        :base="base"
        name="subject"
      >
      </text-field>
      <time-field
        :isForm="false"
        :base="base"
        name="created_at"
        :labelText="$t('api.createdAt')"
        width="100"
      >
      </time-field>
      <std-opt
        :isForm="false"
        name="status"
        type="email"
      >
      </std-opt>
      <template slot-scope="btn" slot="btns">
        <confirm-btn
          btnType="warning"
          btnClass=""
          btnIcon=""
          :msgBase="msgBase"
          :reqPath="sendPath"
          :reqData="{id:[btn.rowid]}"
          :after="getList"
          :tip="$t(msgBase + 'btnTip')"
          :infoText="getInfoText(btn.row)"
        >
          <svg-icon icon-class="baseline-send-24px"></svg-icon>
        </confirm-btn>
        <el-button
          type="primary"
          size="small"
          icon="el-icon-menu"
          @click="$router.push({ path: getLinkPath(btn.row) })"
        >
          {{ getLinkName(btn.row) }}
        </el-button>
      </template>
    </list-table>
  </div>
</template>

<script>

export default {
  name: 'email-list',
  props: {
    base: {
      type: String,
      required: true
    },
    msgBase: {
      type: String,
      required: true
    },
    fetchList: {
      type: Function,
      required: true
    },
    getInfoText: {
      type: Function,
      required: true
    },
    deleteOne: {
      type: Function,
      required: true
    },
    sendPath: {
      type: String,
      required: true
    },
    getLinkPath: {
      type: Function,
      required: true
    },
    getLinkName: {
      type: Function,
      required: true
    },
    hasDocID: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      optionCols: ['status'],
      filterCols: ['id', 'statement_id', 'doc_id'],
      srchFields: ['subject'],
      nameField: 'subject'
    }
  },
  computed: {
    showExSearch () {
      return {
        display: true,
        filterBySOADocumentID: this.hasDocID,
        filterByID: true
      }
    }
  },
  methods: {
    getList () {
      this.$refs.list.getList()
    },
    checkStatus (status) {
      switch (status) {
        case 4:
          return true
      }
      return false
    }
  }
}
</script>
